// @flow
import React from 'react';
import styled from 'styled-components';
import shortid from 'shortid';
import { DropdownList as Dropdown } from 'react-widgets';

import { colors } from '../../../shared/styles';

type DropdownListProps = {
    disabled: boolean,
    input: any,
    label: string,
    multiple?: boolean,
    size?: number,
    data: any,
    meta: any,
};

const StyledDropdownList = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & .rw-dropdownlist {
        width: 100%;
        height: 31px;
        box-sizing: border-box;
        border: solid 1px;
        border-radius: 4px;
        font-size: 14px;
        margin: 0;
        appearance: menulist;

        &,
        &:hover {
            background-color: ${colors.white};
            border-color: ${colors.offWhite};
        }

        &.rw-open {
            &,
            > .rw-input {
                border-radius: 4px 4px 0 0;
            }
        }
    }

    & .rw-dropdownlist > .rw-input,
    & .rw-filter-input > .rw-input {
        height: 29px;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 14px;
        line-height: 17px;
    }

    & .rw-dropdownlist-taglist > li {
        padding-right: .4em;

        > span {
            margin-left: .4em;
        }
    }

    & select[multiple] {
        height: 100%;
    }

    & select[disabled] {
        background: ${colors.offWhiteLighter};
    }

    &.input-error {
        & .rw-dropdownlist {
            border-color: ${colors.error.default};
        }

        span.error {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }
`;

const DropdownList = (props: DropdownListProps) => {
    const { disabled, input, label, data, meta: { touched, error } } = props;

    const id = shortid.generate();
    const wrapperCls = touched && error ? 'input-error' : '';

    return (
        <StyledDropdownList className={wrapperCls}>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <Dropdown
                onChange={item => {
                    input.onChange(item.id);
                }}
                placeholder="Please select..."
                valueField="id"
                textField="label"
                disabled={disabled}
                data={data}
                value={input.value}
                filter="contains"
            />
            {touched &&
                error &&
                <span className="error">
                    {error}
                </span>}
        </StyledDropdownList>
    );
};

export default DropdownList;



// WEBPACK FOOTER //
// ./src/components/shared/forms/DropdownList.js